<template>
  <div class="product-detail-page" :key="$route.fullPath">
   <!-- 导航栏 -->
   <Header />
    <!-- 面包屑 -->
    <section class="breadcrumb-section">
      <div class="breadcrumb-container">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item @click="goHome">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            v-for="(item, index) in breadcrumbItems"
            :key="index"
            @click="handleBreadcrumbClick(item, index)"
          >{{ item.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 产品详情主体 -->
    <section class="product-detail-section">
      <div class="detail-container">
        <!-- 左侧内容 -->
        <div class="detail-main">
          <!-- 产品基本信息 -->
          <div class="product-basic">
            <div class="product-image-large">
              <img :src="getFullImageUrl(product.imageUrl)" :alt="product.productName" />
            </div>
            <div class="product-info-panel">
              <h1 class="product-title">{{ product.productName }}</h1>
              <div class="satisfaction-badge">
                <span class="satisfaction-value">{{ product.satisfactionRate }}</span>
                <span class="satisfaction-label">满意度</span>
              </div>
              <div class="product-meta">
                <p class="meta-item">{{ product.priceInfo }}</p>
                <p class="meta-item">已预约次数:{{ product.bookingCount }}次</p>
                <p class="meta-item">服务周期:{{ product.serviceCycle }}</p>
              </div>
              <button class="btn-booking-large" @click="openBookingDialog">立即预约</button>
            </div>
          </div>

          <!-- 项目介绍 -->
          <div class="detail-block">
            <h2 class="block-title">
              <span class="title-bar"></span>
              项目介绍
            </h2>
            <div class="block-content" :class="Sample==122?'block-content-100':''" v-html="product.projectIntro"></div>
            <!-- 产品视频展示 -->
            <div v-if="product.videoUrl" class="product-video-section">
              <h3 class="video-title">产品视频</h3>
              <div class="video-container">
                <video
                  ref="productVideo"
                  :src="getFullVideoUrl(product.videoUrl)"
                  controls
                  preload="metadata"
                  class="product-video-player"
                  @click="openFullscreen"
                ></video>
              </div>
            </div>
          </div>

          <!-- 检测指标 -->
          <div class="detail-block" v-if="Sample==118 || Sample==120">
            <h2 class="block-title">
              <span class="title-bar"></span>
              样品要求
            </h2>
            <div class="block-content" v-html="product.testIndicators"></div>
          </div>

          <!-- 检测标准 -->
         <!-- <div class="detail-block">
            <h2 class="block-title">
              <span class="title-bar"></span>
              检测标准
            </h2>
            <div class="block-content" v-html="product.testStandards"></div>
          </div> -->

          <!-- 项目介绍（重复区块） -->
         <!-- <div class="detail-block">
            <h2 class="block-title">
              <span class="title-bar"></span>
              项目介绍
            </h2>
            <div class="block-content">
              <p>已实际样品为主</p>
            </div>
          </div> -->
        </div>

        <!-- 右侧边栏 -->
        <div class="detail-sidebar">
          <!-- 客服热线 -->
          <div class="sidebar-block">
            <h3 class="sidebar-title">科研服务咨询</h3>
            <div class="service-info">
              <p class="service-name">叶老师</p>
              <div class="qr-code-large">
                <img v-if="qrCodeImageUrl" :src="qrCodeImageUrl" alt="客服二维码">
                <div v-else class="qr-placeholder-large">QR</div>
              </div>
              <p class="service-desc">一对一为您解答疑惑</p>
              <a href="#" class="scan-link">扫码咨询详情</a>
              <div class="phone-info">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#4a90e2" stroke-width="1.5">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span class="phone-number">19991489026</span>
              </div>
            </div>
          </div>

          <!-- 核心优势 -->
          <div class="sidebar-block">
            <h3 class="sidebar-title">核心优势</h3>
			<div class="recommend-list">
			  <div class="recommend-item">
			    <div class="item-title">百人博士智库</div>
			    <p class="item-desc">百余名跨领域博士技术顾问，专业对口，多年科研检测实战经验</p>
			  </div>
			  <div class="recommend-item">
			    <div class="item-title">12小时极速响应</div>
			    <p class="item-desc">全国高校科研资源加持，咨询需求12小时内快速对接反馈</p>
			  </div>
			  <div class="recommend-item">
			    <div class="item-title">全流程一站式服务</div>
			    <p class="item-desc">检测、模拟、数据分析、绘图润色、全链条闭环服务</p>
			  </div>
			  <div class="recommend-item">
			    <div class="item-title">专业论文级数据分析</div>
			    <p class="item-desc">深度处理原始数据，输出可直接用于期刊论文的标准化成果</p>
			  </div>
			  <div class="recommend-item">
			    <div class="item-title">正规报销保障</div>
			    <p class="item-desc">签订正式合同，提供合规发票与检测报告，报账审计无忧</p>
			  </div>
			  <div class="recommend-item">
			    <div class="item-title">高标准可靠交付</div>
			    <p class="item-desc">数据真实可追溯，交付成果匹配期刊发表与项目验收要求</p>
			  </div>
			</div>
           <!-- <div class="recommend-list">
               <div v-for="item in recommendProducts" :key="item.productId" class="recommend-item" @click="goToDetail(item.productId)">
                <div class="recommend-image">
                  <img :src="getFullImageUrl(item.imageUrl)" :alt="item.productName" />
                </div>
                <p class="recommend-name">{{ item.productName }}</p>
              </div> 
            </div>-->
          </div>
        </div>
      </div>
    </section>

   <!-- 引入 Footer -->
   <Footer />
   
    <!-- 预约弹框 -->
    <BookingDialog 
      v-model:visible="bookingDialogVisible" 
      :product="product"
      @success="handleBookingSuccess"
    />
  </div>
</template>

<script setup>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
import { ref, onMounted, computed,watch  } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getMenuTree, getFooterTree, getContact } from '@/api/website'
import { getProductDetail, getProducts } from '@/api/product'
import BookingDialog from '@/components/BookingDialog.vue'

const router = useRouter()
const route = useRoute()

const BASE_URL = process.env.VUE_APP_BASE_URL || ''

const menuTree = ref([])
let Sample = ref('')
const product = ref({
  productName: '',
  imageUrl: '',
  videoUrl: '',
  satisfactionRate: '99%',
  priceInfo: '',
  bookingCount: 0,
  serviceCycle: '',
  projectIntro: '',
  testIndicators: '',
  testStandards: ''
})
const recommendProducts = ref([])
const bookingDialogVisible = ref(false)

const contactInfo = ref({
  phone: '111-1111-111',
  email: 'san@san@san@san.com',
  address: '上海市浦东新区张江高科技园区',
  qrCodeUrl: ''
})

const footerLinks = ref([])

const getFullImageUrl = (url) => {
  if (!url) return ''
  if (url.startsWith('http')) return url
  return BASE_URL + encodeURI(url)
}

const getFullVideoUrl = (url) => {
  if (!url) return ''
  if (url.startsWith('http')) return url
  return BASE_URL + encodeURI(url)
}

const productVideo = ref(null)

const openFullscreen = () => {
  const video = productVideo.value
  if (video) {
    if (video.requestFullscreen) {
      video.requestFullscreen()
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen()
    } else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen()
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen()
    }
  }
}

const qrCodeImageUrl = computed(() => {
  return getFullImageUrl(contactInfo.value.qrCodeUrl)
})

const breadcrumbItems = computed(() => {
  const items = []

  if (route.query.menuPath) {
    try {
      const menuPath = JSON.parse(route.query.menuPath)
      for (const item of menuPath) {
        items.push({
          name: item.menuName,
          menuId: item.menuId,
          url: item.url
        })
      }
	  Sample.value=menuPath[0].menuId
      return items
    } catch (e) {
      console.error('解析 menuPath 失败:', e)
    }
  }

  if (!menuTree.value.length) {
    return items
  }

  const productName = product.value.productName
  const categoryId = product.value.categoryId

  for (const menu of menuTree.value) {
    if (menu.children) {
      for (const child of menu.children) {
        if (child.menuId === categoryId || child.menuName === productName) {
          items.push({ name: menu.menuName, menuId: menu.menuId, url: menu.url })
          items.push({ name: child.menuName, menuId: child.menuId, url: child.url })
          return items
        }
        if (child.children) {
          for (const sub of child.children) {
            if (sub.menuId === categoryId || sub.menuName === productName) {
              items.push({ name: menu.menuName, menuId: menu.menuId, url: menu.url })
              items.push({ name: child.menuName, menuId: child.menuId, url: child.url })
              return items
            }
          }
        }
      }
    }
  }

  return items
})

const goHome = () => {
  router.push('/')
}

// 点击面包屑项
const handleBreadcrumbClick = (item, index) => {
  // 最后一个不可点击
  if (index === breadcrumbItems.value.length - 1) return

  // 一级菜单：跳转到菜单列表页
  if (index === 0 && item.menuId) {
    router.push({
      path: '/menu',
      query: { menuId: item.menuId }
    })
  }
  // 二级菜单：跳转到菜单列表页并选中该二级
  else if (index === 1 && item.menuId) {
    const parentId = breadcrumbItems.value[0]?.menuId
    router.push({
      path: '/menu',
      query: { menuId: parentId, level2Id: item.menuId }
    })
  }
  // 三级菜单：跳转到对应页面
  else if (item.url) {
    const targetPath = item.url.startsWith('/') ? item.url : '/' + item.url
    router.push(targetPath)
  }
}

const goToProductList = () => {
  router.push('/products')
}

const goToDetail = (productId) => {
  router.push(`/product/${productId}`)
  window.location.reload()
}

// const handleMenuClick = (menu) => {
//   if (menu.menuName === '多功能通用无人机H1') {
//     router.push('/products')
//   }
// }

// const handleSubMenuClick = (sub) => {
//   if (sub.menuName === '产品介绍') {
//     router.push('/product/1')
//   }
// }

const openBookingDialog = () => {
  bookingDialogVisible.value = true
}

const handleBookingSuccess = () => {
  loadProductDetail()
}

const loadProductDetail = async () => {
  try {
    const productId = route.params.id
    const res = await getProductDetail(productId)
    if (res.code === 200 && res.data) {
      product.value = res.data
    }
  } catch (error) {
    console.error('加载产品详情失败:', error)
  }
}

const loadRecommendProducts = async () => {
  try {
    const res = await getProducts({ pageSize: 3 })
    if (res.code === 200) {
      recommendProducts.value = res.rows || []
    }
  } catch (error) {
    console.error('加载推荐产品失败:', error)
  }
}

const loadData = async () => {
  try {
    const [menuRes, footerRes, contactRes] = await Promise.all([
      getMenuTree(),
      getFooterTree(),
      getContact()
    ])

    if (menuRes.code === 200 && menuRes.data) {
      menuTree.value = menuRes.data
    }

    if (footerRes.code === 200 && footerRes.data) {
      footerLinks.value = footerRes.data.map(footer => ({
        title: footer.footerName,
        links: footer.children ? footer.children.map(child => child.footerName) : []
      }))
    }

    if (contactRes.code === 200 && contactRes.rows?.length > 0) {
      const contact = contactRes.rows[0]
      contactInfo.value = {
        phone: contact.hotline || contact.phone || '111-1111-111',
        email: contact.email || 'san@san@san@san.com',
        address: contact.address || '上海市浦东新区张江高科技园区',
        qrCodeUrl: contact.qrCodeUrl || ''
      }
    }

    await loadProductDetail()
    await loadRecommendProducts()
  } catch (error) {
    console.error('加载数据失败:', error)
  }
}
watch(
  () => route.params.id, // 监听路由参数 id
  (newId, oldId) => {
    if (newId !== oldId) { // 确保是不同的 ID
      loadProductDetail() // 重新加载数据
    }
  },
  { immediate: true } // 立即执行一次（处理初始加载）
)
onMounted(() => {
  loadData()
})
</script>

<style scoped>
.product-detail-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1.5;
  color: #333;
  max-width: 1440px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 0 20px rgba(0,0,0,0.05);
  min-height: 100vh;
}


/* 面包屑 */
.breadcrumb-section {
  margin-top: 100px;
  padding: 20px 60px;
  background: #f5f5f5;
}

.breadcrumb-container {
  max-width: 1200px;
  margin: 0 auto;
}

:deep(.el-breadcrumb__item) {
  cursor: pointer;
}

:deep(.el-breadcrumb__item:hover) {
  color: #4a90e2;
}

/* 产品详情主体 */
.product-detail-section {
  padding: 30px 60px;
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 40px;
}

.detail-main {
  flex: 1;
}

.detail-sidebar {
  width: 280px;
  flex-shrink: 0;
}

/* 产品基本信息 */
.product-basic {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
  padding: 30px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.product-image-large {
  width: 300px;
  height: 220px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.product-image-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info-panel {
  flex: 1;
}

.product-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.satisfaction-badge {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 16px;
}

.satisfaction-value {
  font-size: 28px;
  font-weight: 700;
  color: #4a90e2;
}

.satisfaction-label {
  font-size: 14px;
  color: #999;
}

.product-meta {
  margin-bottom: 20px;
}

.meta-item {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.btn-booking-large {
  padding: 12px 40px;
  background: #4a90e2;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-booking-large:hover {
  background: #3a7bc8;
}

/* 详情区块 */
.detail-block {
  margin-bottom: 30px;
  padding: 30px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.block-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.title-bar {
  width: 4px;
  height: 20px;
  background: #4a90e2;
  border-radius: 2px;
}

.block-content {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}
.block-content :deep(img) {
  width: 70%;     
  display: block;
  margin:auto;
}
.block-content-100 :deep(img) {
  width: 100% !important;
}
.block-content :deep(p) {
  margin-bottom: 12px;
}

.block-content :deep(strong) {
  color: #333;
  font-weight: 600;
}

/* 产品视频区域 */
.product-video-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px dashed #e0e0e0;
}

.video-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 3px solid #4a90e2;
}

.video-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.product-video-player {
  width: 100%;
  height: auto;
  max-height: 450px;
  display: block;
  cursor: pointer;
}

/* 侧边栏 */
.sidebar-block {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.sidebar-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 3px solid #4a90e2;
}

.service-info {
  text-align: center;
}

.service-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.qr-code-large {
  width: 160px;
  height: 160px;
  margin: 0 auto 16px;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code-large img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-placeholder-large {
  font-size: 18px;
  color: #999;
}

.service-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.scan-link {
  display: inline-block;
  font-size: 14px;
  color: #4a90e2;
  text-decoration: none;
  margin-bottom: 16px;
}

.phone-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.phone-number {
  font-size: 16px;
  font-weight: 600;
  color: #4a90e2;
}
  .recommend-list {
    /* display: grid; */
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* 响应式网格 */
    gap: 24px;
    /* padding: 40px 20px; */
    /* max-width: 1200px; */
	box-sizing: border-box;
    margin: 0 auto;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }

  /* 卡片基础样式 */
  .recommend-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    gap: 5px;
	margin-bottom: 10px;
  }

  /* 悬停效果 */
  .recommend-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 123, 255, 0.1);
    border-color: #007bff;
  }

  /* 标题样式 */
  .item-title {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  /* 标题前的装饰点/图标 */
  .item-title::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #007bff;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* 描述文字样式 */
  .item-desc {
    font-size: 14px;
    line-height: 1.6;
    color: #666666;
    margin: 0;
  }
/* 推荐案例 */
/* .recommend-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
} */

.recommend-item {
  cursor: pointer;
  transition: all 0.2s;
}

.recommend-item:hover {
  opacity: 0.8;
}

.recommend-image {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
}

.recommend-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recommend-name {
  font-size: 14px;
  color: #333;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


</style>
